import { useProject } from '../../context/ProjectContext';
import { useDashboard } from '../../context/DashboardContext';
import BackButton from '../Common/BackButton';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import overviewIcon from '../../assets/overview.svg';
import folderIcon from '../../assets/folder.svg';

const ProjectsSidebar = ({ onCreateProject, onEditProject, onDeleteProject, onClose }) => {
    const {
        projects,
        activeProjectId,
        selectProject,
        loadingProjectId,
    } = useProject();
    const { highlightedTeamId, setActiveView, returnView } = useDashboard();

    const handleProjectClick = (projectId) => {
        selectProject(projectId);
        if (onClose) onClose();
    };

    const handleEditClick = (e, project) => {
        e.stopPropagation();
        onEditProject?.(project);
    };

    const handleDeleteClick = (e, project) => {
        e.stopPropagation();
        onDeleteProject?.(project);
    };

    return (
        <div className="projects-sidebar">
            <div className="projects-sidebar-header" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <BackButton onClick={() => setActiveView(returnView)} ariaLabel="Back to Dashboard" />
                <button className="projects-create-btn" onClick={onCreateProject} style={{ flex: 1, width: 'auto' }}>
                    <FaPlus size={16} />
                    <span>Create Project</span>
                </button>
                {onClose && (
                    <button className="projects-sidebar-close-btn" onClick={onClose}>
                        <svg viewBox="0 0 24 24" width="20" height="20" stroke="currentColor" strokeWidth="2" fill="none"><path d="M18 6L6 18M6 6l12 12"/></svg>
                    </button>
                )}
            </div>

            <div className="projects-sidebar-nav">
                <span className="projects-nav-label">Dashboard</span>
                <div
                    className={`projects-nav-item ${!activeProjectId ? 'active' : ''}`}
                    onClick={() => {
                        selectProject(null);
                        if (onClose) onClose();
                    }}
                >
                    <img src={overviewIcon} alt="" className="projects-nav-icon" />
                    <span>Projects Overview</span>
                </div>
            </div>

            <div className="projects-section-header">
                <span className="projects-section-title">My Projects</span>
            </div>

            <div className="projects-list">
                {projects.map(project => (
                    <div
                        key={project.id}
                        className={`project-list-item ${activeProjectId === project.id ? 'active' : ''
                            } ${loadingProjectId === project.id ? 'loading' : ''
                            } ${highlightedTeamId && project.team_id === highlightedTeamId ? 'highlighted' : ''
                            }`}
                        onClick={() => handleProjectClick(project.id)}
                    >
                        <img src={folderIcon} alt="" className="project-folder-icon" />
                        <span className="project-item-name">{project.title}</span>

                    </div>
                ))}

                {projects.length === 0 && (
                    <div className="projects-empty">
                        <p>No projects yet</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectsSidebar;
